import { useMutation } from "react-query";
import { postAmendRiskCheck } from "store/api/api";
import { handleAxiosError } from "store/util";
import { AmendRiskCheckRequest } from "types/types";
import { MUTATION_KEYS } from "../queryKeys";

export function useAmendRiskCheck() {
  return useMutation(
    ({
      fleetId,
      vehicleId,
      data,
    }: {
      fleetId: number;
      vehicleId: number;
      data: AmendRiskCheckRequest;
    }) => postAmendRiskCheck(fleetId, vehicleId, data),
    {
      mutationKey: MUTATION_KEYS.amendRiskCheck,
      onError: (err) => {
        handleAxiosError(err);
      },
    },
  );
}
